<template>
    <div class="sopCard">
        <div style="width: 100%; text-align: center; word-wrap: break-word;">
            <span>{{code}}</span>
        </div>
        <div style="width: 100%; text-align: center;">
            <i style="font-size: 3rem;" class="fas" :class="getIconType" ></i>
        </div>
        <div class="mt-1 text-truncate" style="width: 100%; text-align: center;">
            <p style="font-size: 0.75rem; text-transform: capitalize;" class=" text-wrap mb-0">{{name.toLowerCase()}}</p>
        </div>
    </div>
</template>

<script>
export default {
    data:() => ({}),
    props:{
        name:{
            default: 'Test'
        },
        code:{
            default: 'test',
        },
        builder_enabled:{
            default: false,
        }
    },
    computed:{
        getIconType(){
            // CCB Admin users have no builder flag, so ignore it :)
            if(this.$store.getters['clientAdmin/userType'] == 'admin'){
                return 'fa-file'
            }
            else{
                return this.builder_enabled ? 'fa-file' : 'fa-file-pdf'
            }
            
        }
    },
    methods:{},
    mounted(){},
}
</script>

<style>
.sopCard{
    padding: 0.2rem;
}
</style>